import React from "react";
import {TextValidator} from "components"; // your customized wrapper
import { InputAdornment } from "@mui/material";

/**
 * Reusable ColorPickerValidator with hex input + color preview square.
 *
 * @param {object} props - Props for the component.
 * @param {string} props.name - Field name.
 * @param {string} props.value - Current color value.
 * @param {function} props.onChange - Change handler.
 * @param {string[]} [props.validators] - Validation rules.
 * @param {string[]} [props.errorMessages] - Error messages.
 * @param {boolean} [props.required] - Whether required.
 * @param {string} [props.label] - Field label.
 */
const ColorPickerValidator = ({ value, onChange, ...props }) => {
  return (
    <TextValidator
      {...props}
      value={value}
      onChange={onChange}
      
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {/* Hidden native color input */}
            <input
              type="color"
              value={value}
              onChange={onChange}
              style={{
                width: "24px",
                height: "24px",
                border: "none",
                padding: 0,
                background: "none",
                cursor: "pointer",
              }}
            />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ColorPickerValidator;
